<mat-card class="mat-card-contract-slice">
  <mat-card-header>
    <mat-card-title>{{ 'contract-slice.title' | translate }}</mat-card-title>
    <!-- <mat-card-subtitle>Veuillez saisir tout les champs</mat-card-subtitle> -->
  </mat-card-header>
  <form [formGroup]="contractSliceForm" (ngSubmit)="onSubmit()">
    <mat-card-content>
      <div class="content-row" *ngIf="!data?.contractSlice?.isLastSlice">
        <label class="content-row-label">{{ 'label.tonnage' | translate }}</label>
        <span class="required-asterisk" *ngIf="isRequiredField('tonnage')">*</span>
        <mat-form-field class="content-row-input">
          <input matInput formControlName="tonnage" type="number" autocomplete="off">
          <span matSuffix>{{ 'label.tonne(s)' | translate }}</span>
        </mat-form-field>
      </div>
      <div class="content-row" *ngIf="data?.contractSlice?.isLastSlice">
        <label for="isLastSliceCheckbox" class="content-row-label" style="display: flex;
        align-items: center;">{{ 'label.is-last-slice' | translate
          }}<mat-icon [matTooltip]="'label.is-last-slice-info' | translate" style="margin-left: 10px;">info</mat-icon>
          </label>
        <mat-checkbox id="isLastSliceCheckbox" formControlName="isLastSlice">
        </mat-checkbox>
      </div>
      <div class="content-row">
        <label class="content-row-label">{{ 'label.price' | translate }}</label>
        <span class="required-asterisk" *ngIf="isRequiredField('price')">*</span>
        <mat-form-field class="content-row-input">
          <input matInput formControlName="price" type="number" autocomplete="off">
          <span matSuffix>€</span>
        </mat-form-field>
      </div>

      <div class="content-row">
        <label class="content-row-label">{{ 'label.price-index' | translate }}</label>
        <div class="content-row-input" style="justify-content: flex-end;display: flex;">
          <span>{{indexPrice | number :'0.6' :'fr'}}</span>
          <span matSuffix> €</span>
        </div>
      </div>

    </mat-card-content>
    <mat-card-actions class="contract-slice-card-action">
      <button mat-raised-button color="warn" *ngIf="dialogRef" type="button" (click)="onCancel()">
        <mat-icon>clear</mat-icon> {{ 'button.cancel' | translate }}
      </button>
      <button mat-raised-button color="primary" [disabled]="contractSliceForm.invalid">
        <mat-icon>save</mat-icon> {{ 'button.save' | translate }}
      </button>
    </mat-card-actions>
  </form>
</mat-card>